import React, { createRef, useEffect } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import {
  Game,
  Cards,
  FinalResult,
  Result,
  Win,
  Lobby,
  Prompt,
  VerbodenGame,
  TotGame,
  DoneWith2020,
  ChartyGame,
  launchController,
  OCHGame,
  CTGame,
  SlideKickHomepage,
  Fluster,
  Bingo,
  wrongHost,
  MyTeam,
  TrialLoginForm,
  smallBitess,
  TeamReports,
  NotSignedIn,
  LandingLibrary,
  TeamChallenges,
  Activities,
  Billing,
  InvalidURL,
  SignUp,
  PricingComponent,
  DeleteAccount,
  DeleteAccountSuccess,
  PasswordReset,
  Account,
  InviteTeammates
} from "pages";
import GamePlay from "pages/verbodenGame/gamePlay";
import VerbodenGameResult from "pages/verbodenGame/result";
import VerbodenGameFinal from "pages/verbodenGame/final";

const PublicRoute = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        !rest.roomCreated && rest.deleteAccount ? (
          <Redirect
            to={{
              pathname: "/signup",
              state: { from: props.location }
            }}
          />
        ) : rest.roomCreated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export const historyRef = createRef();

const Routes = () => {
  const {
    gameReducer: { roomObj, currentUser }
  } = useSelector((state) => state);

  const history = useHistory();
  historyRef.current = history;
  const roomCreated = !isEmpty(roomObj);
  const isLoggedIn = !isEmpty(currentUser);

  useEffect(() => {
    const location = window.location.href;
    const search = location.includes("?") ? "?" + location.split("?")[1] : "";
    if (!search) return;
    localStorage.setItem("temp_utm_medium", localStorage.getItem("utm_medium"));
    localStorage.setItem("temp_utm_source", localStorage.getItem("utm_source"));
    localStorage.setItem(
      "temp_utm_campaign",
      localStorage.getItem("utm_campaign")
    );
    localStorage.setItem(
      "temp_utm_content",
      localStorage.getItem("utm_content")
    );
    localStorage.removeItem("utm_medium");
    localStorage.removeItem("utm_source");
    localStorage.removeItem("utm_campaign");
    localStorage.removeItem("utm_content");
    const utm_medium = new URLSearchParams(search).get("utm_medium");
    const utm_source = new URLSearchParams(search).get("utm_source");
    const utm_campaign = new URLSearchParams(search).get("utm_campaign");
    const utm_content = new URLSearchParams(search).get("utm_content");
    if (utm_source !== null) {
      localStorage.setItem("utm_source", utm_source);
    }
    if (utm_medium !== null) {
      localStorage.setItem("utm_medium", utm_medium);
    }
    if (utm_campaign !== null) {
      localStorage.setItem("utm_campaign", utm_campaign);
    }
    if (utm_content !== null) {
      localStorage.setItem("utm_content", utm_content);
    }
  }, []);

  return (
    <Switch>
      <PublicRoute exact path="/" component={LandingLibrary} />
      <PublicRoute
        exact
        path="/launch_controller"
        component={launchController}
      />
      <PublicRoute exact path="/my-team" component={MyTeam} />
      <PublicRoute exact path="/team-reports" component={TeamReports} />
      <PublicRoute
        exact
        path="/team-challenges/challenges-library"
        component={TeamChallenges}
      />
      <PublicRoute
        exact
        path="/team-challenges/view-challenge"
        component={TeamChallenges}
      />
      <PublicRoute
        exact
        path="/team-challenges/challenges-use-Template"
        component={TeamChallenges}
      />
      <PublicRoute
        exact
        path="/team-challenges/create-new-challenge"
        component={TeamChallenges}
      />
      <PublicRoute exact path="/no-team" component={NotSignedIn} />
      <PublicRoute exact path="/landing-library" component={LandingLibrary} />
      <PublicRoute exact path="/game-library" component={LandingLibrary} />
      <PublicRoute exact path="/activities" component={Activities} />
      <PublicRoute exact path="/lobby" component={Lobby} />
      <PrivateRoute
        exact
        path="/game"
        roomCreated={roomCreated}
        component={Game}
      />
      <PrivateRoute
        exact
        path="/final-result"
        roomCreated={roomCreated}
        component={FinalResult}
      />
      <PrivateRoute
        exact
        path="/prompt"
        roomCreated={roomCreated}
        component={Prompt}
      />
      <PrivateRoute
        exact
        path="/result"
        roomCreated={roomCreated}
        component={Result}
      />
      <PrivateRoute
        exact
        path="/win"
        roomCreated={roomCreated}
        component={Win}
      />
      <PrivateRoute
        exact
        path="/cards"
        roomCreated={roomCreated}
        component={Cards}
      />
      <PublicRoute exact path="/verboden" component={VerbodenGame} />
      <PublicRoute exact path="/verboden/play" component={GamePlay} />
      <PublicRoute
        exact
        path="/verboden/result"
        component={VerbodenGameResult}
      />
      <PublicRoute exact path="/verboden/final" component={VerbodenGameFinal} />
      <PublicRoute exact path="/tot" component={TotGame} />
      <PublicRoute exact path="/done-with-2020" component={DoneWith2020} />

      <PublicRoute exact path="/ochos-locos" component={OCHGame} />
      <PublicRoute exact path="/charty-game" component={ChartyGame} />
      <PublicRoute exact path="/slidekick" component={SlideKickHomepage} />
      <PublicRoute exact path="/ct-game" component={CTGame} />
      <PublicRoute exact path="/fluster" component={Fluster} />
      <PublicRoute exact path="/wronghost" component={wrongHost} />
      <PublicRoute exact path="/trial-login" component={TrialLoginForm} />
      <PublicRoute exact path="/bingo" component={Bingo} />
      <PublicRoute exact path="/smallBites" component={smallBitess} />
      <PublicRoute exact path="/billing" component={Billing} />
      <PrivateRoute
        exact
        path="/signup"
        component={SignUp}
        roomCreated={!isLoggedIn}
      />
      <PrivateRoute
        exact
        path="/pricing_page"
        component={PricingComponent}
        roomCreated={isLoggedIn}
      />
      <PrivateRoute
        exact
        path="/delete_account"
        component={DeleteAccount}
        roomCreated={isLoggedIn}
        deleteAccount={true}
      />
      <PublicRoute
        exact
        path="/delete_account_success"
        component={DeleteAccountSuccess}
      />
      <PublicRoute exact path="/password_reset" component={PasswordReset} />
      <PublicRoute exact path="/account" component={Account} />
      <PublicRoute exact path="/invite_teammates" component={InviteTeammates} />
      <PublicRoute path="*" component={InvalidURL} />
    </Switch>
  );
};

export default Routes;
